import Vue from 'vue';
import fullSceenTipsVue from './fullSceenTips.vue';
import merge from '@/utils/merge';

const defaults = {
    html: '加载中'
};
const fullSceenTipsConstructor = Vue.extend(fullSceenTipsVue);

fullSceenTipsConstructor.prototype.close = function() {
    if (this._el != null) {
        document.body.removeChild(this._el) //从body中移除dom
    }
    if (this._instance != null) {
        this._instance.$destroy() //销毁组件
    }
    if (this._vm != null) {
        this._vm = null //让GC回收
    }
    window.__fullSceenTips = null;
}

const FullSceenTips = (options => {
    options = merge({}, defaults, options);
    let instance = new fullSceenTipsConstructor({
        data: options
    });
    instance._vm = instance.$mount()
    instance._el = instance.$el
    instance._instance = instance
    document.body.appendChild(instance.$el) // 把生成的提示的dom插入body中
    return instance;
})

export default FullSceenTips